/* eslint-disable max-lines-per-function */
import { EventBus, Events, store } from "jiffy-store";
import { api } from "jiffy-api";
import { isCustomizableMadePage } from "components/jiffy/product-details/customizable-made-page-utils";

const loadedColorsCollection = new Set();

const getWrapper = () => document.getElementById("js-product-mobile-grid");

const setLoadingStatus = loading => {
  const $loading = getWrapper();

  $loading.classList.toggle("product-details-variants-form__grid-wrapper--loading", loading);
};

const fetchGrid = async (productId, { activeColor }, callback) => {
  const $wrapper = getWrapper();
  if (loadedColorsCollection.has(activeColor)) return;

  loadedColorsCollection.add(activeColor);
  setLoadingStatus(true);

  const payload = {
    ac: activeColor
  };

  if (isCustomizableMadePage()) {
    payload.made_dedicated_pdp = true;
  }

  const mobileGridResponce = await api.product.fetchWithColorMobileGrid({ productId }, payload, {
    cacheable: true
  });
  const dataHtml = document.createElement("div");

  dataHtml.innerHTML = mobileGridResponce.grid || "";
  Array.from(dataHtml.children).forEach(node => {
    $wrapper.appendChild(node.cloneNode(true));
  });

  setLoadingStatus(false);

  // Call fetchGridCallback after grid is loaded
  if (callback instanceof Function) callback(activeColor);
};

export default (productId, activeColor, callback) => {
  if (activeColor) {
    loadedColorsCollection.add(activeColor);
  }

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (_, { color }) => {
    const { loaded } = store.get(state => ({
      loaded: state.ui.inventoryLoaded,
      loading: state.ui.inventoryLoading
    }));
    const payload = { activeColor: color };

    if (loaded) {
      fetchGrid(productId, payload, callback);
    } else {
      setLoadingStatus(true);
      store.pdp.change({ isFetchingInventory: true, fetchingSlug: productId });

      const listener = store.ui.changed((__, { data }) => {
        if (data.inventoryLoaded) {
          fetchGrid(productId, payload, callback);
          listener && listener();
        }
      });
    }
  });
};
